// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const palkia: PokeData = {
  "id": 484,
  "name": "palkia",
  "height": 42,
  "weight": 3360,
  "base_experience": 306,
  "types": [
    PokeType.WATER,
    PokeType.DRAGON
  ],
  "api_moves": [
    "hydro-pump",
    "slash",
    "scary-face",
    "dragon-breath",
    "twister",
    "ancient-power",
    "dragon-claw",
    "water-pulse",
    "heal-block",
    "aqua-ring",
    "aura-sphere",
    "aqua-tail",
    "dragon-pulse",
    "power-gem",
    "earth-power",
    "spacial-rend"
  ],
  "moves": [
    "hydro-pump",
    "scary-face",
    "dragon-breath",
    "ancient-power",
    "dragon-claw",
    "aqua-tail",
    "dragon-pulse",
    "earth-power",
    "dragon-dance",
    "dragon-vortex",
    "life-dew",
    "rain-dance",
    "dragon-rush"
  ],
  "evolution_chain": {
    "id": 245,
    "item": null,
    "species": [
      {
        "name": "palkia",
        "order": 485,
        "types": [
          PokeType.WATER,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 114,
    "speed": 114,
    "ability_power": 171
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
